import React from "react";
import Page from "../components/Page";

// Import
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { usePullSlug } from "../hooks/usePullSlug";
import { useEffect } from "react";
import { useTitle } from "../hooks/useTitle";

// Import for Display
import RichText from "../components/RichText";
import LoadingPage from "./LoadingPage";

function TemplatePage() {
  const { data } = useSelector((state) => state.cms);

  // Access data for this specific entry.
  let { slug } = useParams();

  const collectionSlug = "pages";
  // const entryData = usePullSlug(collectionSlug, data, slug);
  const collectionData = data[collectionSlug];

  // Only load if data has returned.
  if (!collectionData) return <LoadingPage />;

  //   pull out only the collection data for this specific category
  let filteredCollectionData = collectionData.filter((el) => el.attributes.title === slug || el.attributes.slug === slug)[0].attributes;

  //console.log(filteredCollectionData);

  // useTitle(entryData.title);
  return (
    <Page data-wf-page="6ss3505921d76cc5c32f8050da" data-wf-site="634efd6b20b65bfc05be44e4">
      {/* Header */}
      <div
        className="section wf-section"
        style={{
          height: "50vh",
          backgroundImage: `url(${filteredCollectionData.coverImage.data && filteredCollectionData.coverImage.data.attributes.url}`,
          backgroundPosition: "50% 100%",
          backgroundSize: "cover",
        }}
      ></div>

      {/* Content */}
      <div className="section wf-section">
        <div className="container w-container">
          <h1>{filteredCollectionData.title}</h1>
          <RichText text={filteredCollectionData.body} />
        </div>
      </div>
    </Page>
  );
}

export default TemplatePage;
